var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46842 11.9189L8.5 8.88737L11.5316 11.9189L12.4189 11.0316L9.38737 8L12.4189 4.96842L11.5316 4.08105L8.5 7.11263L5.46842 4.08105L4.58105 4.96842L7.61263 8L4.58105 11.0316L5.46842 11.9189ZM8.50147 16C7.39495 16 6.35488 15.79 5.38126 15.3701C4.40765 14.9502 3.56077 14.3803 2.84063 13.6604C2.12049 12.9406 1.55032 12.094 1.13011 11.1208C0.710035 10.1476 0.5 9.10786 0.5 8.00147C0.5 6.89495 0.709965 5.85488 1.12989 4.88126C1.54982 3.90765 2.11972 3.06077 2.83958 2.34063C3.55944 1.62049 4.40597 1.05032 5.37916 0.630105C6.35235 0.210035 7.39214 0 8.49853 0C9.60505 0 10.6451 0.209965 11.6187 0.629894C12.5924 1.04982 13.4392 1.61972 14.1594 2.33958C14.8795 3.05944 15.4497 3.90597 15.8699 4.87916C16.29 5.85235 16.5 6.89214 16.5 7.99853C16.5 9.10505 16.29 10.1451 15.8701 11.1187C15.4502 12.0924 14.8803 12.9392 14.1604 13.6594C13.4406 14.3795 12.594 14.9497 11.6208 15.3699C10.6476 15.79 9.60786 16 8.50147 16Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.28358f80b63d50c162b088acd3dfdb24.svg";
export { ForwardRef as ReactComponent };